const lit = (val) => val;

export { lit };
//# sourceMappingURL=literal.js.map
